import { Carousel, Carousel_CoreInit, Accordion, Popup, Form, Form_CoreInit, Burger, Mobile, Header_CoreInit } from './core'
import Header from './modules/header'
import Chatbot from './modules/chatbot'
import Favorites from './modules/favorites'
import Calendar from './modules/calendar'
import './modules/audio-player'
import Swiper, { EffectCoverflow } from 'swiper'
Swiper.use([EffectCoverflow])

Carousel_CoreInit([
  {
    classSelector: 'carousel--style--standard',
    swiperOptions: {},
  },
  {
    classSelector: 'carousel--style--coverflow',
    swiperOptions: {
      loop: true,
      slidesPerView : 'auto',
      centeredSlides : true,
      effect : 'coverflow',
      loopAdditionalSlides: 5,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 300,
        modifier: 3,
        slideShadows : true
      },
    },
  },
  {
    classSelector: 'carousel--style--stocks',
    swiperOptions: {
      loop: true,
      slidesPerView : 'auto',
      loopAdditionalSlides: 5,
      breakpoints: {
        0: {
          slidesPerView : 'auto',
        },
        768: {
          slidesPerView : 'auto',
          centeredSlides : true,
        },
      }
    },
  },
  {
    classSelector: 'carousel--style--social',
    swiperOptions: {
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    },
  },
  {
    classSelector: 'carousel--style--offer',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView : 1.2,
          centeredSlides: true,
          initialSlide: 1,
        },
        768: {
          slidesPerView : 'auto',
        },
      }
    },
  }
])

Form_CoreInit([
  {
    classSelector: 'builder-form--contact',
    formOptions: {},
  },
  {
    classSelector: 'builder-form--newsletter',
    formOptions: {
      onInit: function(form) {
        let $unsubscribe = form.find('input[name="email_preferences[]"][value="unsubscribe"]'),
        $preferences = form.find('input[name="email_preferences[]"]').not($unsubscribe)
        function togglePreferences() {
          if ($unsubscribe.is(':checked')) {
            $preferences.prop('checked', false).prop('disabled', true)
          } else {
            $preferences.prop('disabled', false)
          }
        }
        $unsubscribe.on('change', togglePreferences)
        togglePreferences()
      },
    },
  },
])

Header_CoreInit()

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    favorites: undefined,
    login_modal: undefined,
    login_form: undefined,
  }

  /* Login */
  // $.mlmi.login_modal = $('.modal-box').Popup({
  //   close_selector: '.modal-box__close',
  // })
  // $(document).on('click', '.js-login', function(e) {
  //   e.preventDefault()
  //   $.mlmi.login_modal.display()
  // })
  // $.mlmi.login_form = new Form($('.user-form--login'), {
  //   locale: 'en',
  //   onSuccess: function(response, form) {
  //     form.css('height', form.outerHeight(false))
  //     form.find('> .row').fadeOut(200, function() {
  //       let $instruction = $('<div class="magic-link-instruction"></div>').html(response.instruction).hide()
  //       form.append($instruction.fadeIn(200))
  //     })
  //   },
  // })
  // if (window.location.hash == '#login') {
  //   history.replaceState(null, '', window.location.pathname + window.location.search)
  //   if (!$('body').hasClass('--pro')) {
  //     $.mlmi.login_modal.display()
  //   }
  // }

  /* Register */
  // new Form($('.user-form--register'), {
  //   onSuccess: function(response, form) {
  //     form.css('height', form.outerHeight(false))
  //     form.find('> .row').fadeOut(200, function() {
  //       let $instruction = $('<div class="magic-link-instruction"></div>').html(response.instruction).hide()
  //       form.append($instruction.fadeIn(200))
  //     })
  //   },
  // })

  /* Profile */
  new Form($('.user-form--profile'), {
    onSuccess: function(response, form) {
      //
    },
  })

  /* Audio player */
  $('.audio-player').each(function() {
    $(this).AudioPlayer()
  })

  /* Accordéons */
  Accordion.init()

  /* Popups */
  Popup.init()

  /* Lightbox */
  Lightbox_PluginInit()

  /* Fixed content */
  FixedContent_PluginInit()

  /* Post Share */
  PostShare_PluginInit()

  /* Header */
  Header.init()

  /* Chatbot */
  Chatbot.init()

  /* Favorites */
  Favorites.init()

  /* Header search */
  HeaderSearch_PluginInit()

  /* Video loop */
  VideoLoop_PluginInit()

  $('.btn-icon, .btn-icon-left, .btn-back').each(function() {
    $(this).html('<span>' + $(this).html() + '</span>')
  })

  $('.card-full__details, .card-spotlight.--extra-full .card-spotlight__details').each(function() {
    $(this).Tags()
  })

  /* Scroll to anchors */
  $('a[href^=#]:not([href$=#])').each(function() {
    $(this).scrollToAnchor()
  })

  $('.table-of-content').each(function() {
    $(this).SelectedAnchor()
  })

  $('.grid__header__title').each(function() {
    $(this).GridTitle()
  })

  /* Rolling text module */
  $('.rolling-text').each(function() {
    $(this).RollingBanner()
  })

  $('.pop-links').each(function() {
    $(this).Drawer({
      toggle: '.pop-links__toggle',
      content: '.pop-links__content'
    })
  })

  $('.filter-drawer').each(function() {
    $(this).Drawer({
      toggle: '.filter-drawer__toggle',
      content: '.filter-drawer__items'
    })
  })

  $('.card-tech-icon__description').each(function() {
    $(this).Drawer({
      toggle: '.card-tech-icon__cta',
      content: '.card-tech-icon__description-content'
    })
  })

  $('.ti500-categories').each(function() {
    $(this).TI500Filters()
  })

  $('.grid--postitem__tech-icon').each(function() {
    $(this).TI500()
  })

  let logo_animation = lottie.loadAnimation({
    container: $('.lottie-logo-gray').get(0),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/img/lottie/logo-gray.json'
  })

  $('.pricing-table-toggle').each(function() {
    let $pricingTableToggle = $(this),
    $pricingTable = $('.carousel--style--offer')
    $(this).find('button').on('click', function() {
      let $pricingButton = $(this)
      $pricingTableToggle.find('button').attr('aria-expanded', 'false')
      $(this).attr('aria-expanded', 'true')
      $('.card-offer__pricing__monthly, .card-offer__pricing__yearly').fadeOut(200).promise().done(function() {
        $('.card-offer__pricing__' + $pricingButton.data('type')).fadeIn(280)
        if ($pricingButton.data('type') == 'monthly') {
          $pricingTable.find('.card-offer__cta').each(function() {
            $(this).attr('href', $(this).attr('href').replace('yearly', 'monthly'))
          })
        } else {
          $pricingTable.find('.card-offer__cta').each(function() {
            $(this).attr('href', $(this).attr('href').replace('monthly', 'yearly'))
          })
        }
      })
    })
  })

  /* Calendar */
  Calendar.init()
})
